package nl.volleyplanner.api.entities

import kotlinx.serialization.Serializable
import nl.volleyplanner.api.sports.Club

@Serializable
data class VolunteerJob(
    val jobGroup: String,
    val jobName: String,
    val score: Int,
    val availableForTasks: Boolean
)